import axios from 'axios';
import { authHeader, getToken } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const BASE_URL = `${API_URL}/api/admin`;

export const getDashboard = () => axios.get(`${BASE_URL}/dashboard`, authHeader());
export const getAdminOrders = () => axios.get(`${BASE_URL}/orders`, authHeader());
export const updateOrderStatus = (orderId, status) => axios.patch(`${BASE_URL}/orders/${orderId}/status`, { status }, authHeader());
export const getAdminUsers = () => axios.get(`${BASE_URL}/users`, authHeader());
export const deleteProduct = (productId) => axios.delete(`${BASE_URL}/products/${productId}`, authHeader());
export const getOrderDetail = (orderId) => axios.get(`${BASE_URL}/orders/${orderId}`, authHeader());
export const getMonthlySales = (year) => axios.get(`${BASE_URL}/stats/monthly?year=${year}`, authHeader());
export const getStatsByPeriod = (period) => axios.get(`${BASE_URL}/stats/period?period=${period}`, authHeader());
export const getAdminProducts = () => axios.get(`${BASE_URL}/products`, authHeader());
export const updateProduct = (productId, formData) =>
    axios.patch(`${BASE_URL}/products/${productId}`, formData, {
        headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' }
    });
export const createProduct = (formData) =>
    axios.post(`${API_URL}/api/products`, formData, {
        headers: { ...authHeader().headers, 'Content-Type': 'multipart/form-data' }
    });
export const getCategories = () => axios.get(`${API_URL}/api/categories`, authHeader());
export const getProductOptions = (productId) => axios.get(`${API_URL}/api/products/${productId}/options`, authHeader());
export const addProductOption = (productId, data) => axios.post(`${API_URL}/api/products/${productId}/options`, data, authHeader());
export const deleteProductOption = (productId, optionId) => axios.delete(`${API_URL}/api/products/${productId}/options/${optionId}`, authHeader());
export const getAdminCategories = () => axios.get(`${BASE_URL}/categories`, authHeader());
export const createCategory = (data) => axios.post(`${BASE_URL}/categories`, data, authHeader());
export const updateCategory = (categoryId, data) => axios.put(`${BASE_URL}/categories/${categoryId}`, data, authHeader());
export const deleteCategory = (categoryId) => axios.delete(`${BASE_URL}/categories/${categoryId}`, authHeader());
export const updateShippingInfo = (orderId, data) => axios.patch(`${BASE_URL}/orders/${orderId}/shipping`, data, authHeader());
export const deleteProductImage = (productId, imageId) =>
    axios.delete(`${BASE_URL}/products/${productId}/images/${imageId}`, authHeader());